/* eslint-disable no-console */
import { mapQuoteToApiFormat, mapApiFormatToQuote, resetQuote } from '@/helpers'

export const state = () => ({
  mtaChanges: [],
  mtaQuote: {},
  mtaQuoteLoading: false,
  mtaQuoteError: '',

  mtaPaymentAnnuallyStatus: null,
  mtaPaymentAnnuallyLoading: false,
  mtaPaymentAnnuallyError: '',

  mtaPaymentRetryStatus: null,
  mtaPaymentRetryLoading: false,
  mtaPaymentRetryError: '',

  mtaPaymentMonthlyStatus: null,
  mtaPaymentMonthlyLoading: false,
  mtaPaymentMonthlyError: '',

  mtaPaymentCardlessStatus: null,
  mtaPaymentCardlessLoading: false,
  mtaPaymentCardlessError: '',
})
export const getters = {
  mtaChanges(state) {
    return state.mtaChanges
  },
  mtaQuote(state) {
    return state.mtaQuote
  },
  mtaQuoteLoading(state) {
    return state.mtaQuoteLoading
  },
  mtaQuoteError(state) {
    return state.mtaQuoteError
  },
  balance(state) {
    if (state.mtaQuote.balance) {
      return {
        currentPolicyPremium: state.mtaQuote.origin.price.total || 0,
        newPolicyPremium: state.mtaQuote.price.total || 0,
        newGross: state.mtaQuote.balance.balance_price.gross || 0,
        ipt:
          state.mtaQuote.balance.balance_price.total -
            state.mtaQuote.balance.balance_price.gross || 0,
        toBePaidReturnBalance: state.mtaQuote.balance.balance_price.total || 0,
      }
    } else {
      return {}
    }
  },
  // Annually
  mtaPaymentAnnuallyStatus(state) {
    return state.mtaPaymentAnnuallyStatus
  },
  mtaPaymentAnnuallyLoading(state) {
    return state.mtaPaymentAnnuallyLoading
  },
  mtaPaymentAnnuallyError(state) {
    return state.mtaPaymentAnnuallyError
  },
  // Monthly
  mtaPaymentMonthlyStatus(state) {
    return state.mtaPaymentMonthlyStatus
  },
  mtaPaymentMonthlyLoading(state) {
    return state.mtaPaymentMonthlyLoading
  },
  mtaPaymentMonthlyError(state) {
    return state.mtaPaymentMonthlyError
  },
  // Cardless
  mtaPaymentCardlessStatus(state) {
    return state.mtaPaymentCardlessStatus
  },
  mtaPaymentCardlessLoading(state) {
    return state.mtaPaymentCardlessLoading
  },
  mtaPaymentCardlessError(state) {
    return state.mtaPaymentCardlessError
  },
  // Retry
  mtaPaymentRetryStatus(state) {
    return state.mtaPaymentRetryStatus
  },
  mtaPaymentRetryLoading(state) {
    return state.mtaPaymentRetryLoading
  },
  mtaPaymentRetryError(state) {
    return state.mtaPaymentRetryError
  },
}
export const mutations = {
  SET_MTA_QUOTE: (state, mtaQuote) => {
    state.mtaQuote = mtaQuote
  },
  SET_MTA_CHANGES: (state, changes) => {
    state.mtaChanges = changes
  },
  SET_MTA_QUOTE_LOADING: (state, payload) => {
    state.mtaQuoteLoading = payload
  },
  SET_MTA_QUOTE_ERROR: (state, payload) => {
    state.mtaQuoteError = payload
  },
  // ANNUALLY
  SET_MTA_PAYMENT_QUOTE_ANNUALLY: (state, status) => {
    state.mtaPaymentAnnuallyStatus = status
  },
  SET_MTA_PAYMENT_QUOTE_ANNUALLY_LOADING: (state, payload) => {
    state.mtaPaymentAnnuallyLoading = payload
  },
  SET_MTA_PAYMENT_QUOTE_ANNUALLY_ERROR: (state, payload) => {
    state.mtaPaymentAnnuallyError = payload
  },
  // MONTHLY
  SET_MTA_PAYMENT_QUOTE_MONTHLY: (state, status) => {
    state.mtaPaymentMonthlyStatus = status
  },
  SET_MTA_PAYMENT_QUOTE_MONTHLY_LOADING: (state, payload) => {
    state.mtaPaymentMonthlyLoading = payload
  },
  SET_MTA_PAYMENT_QUOTE_MONTHLY_ERROR: (state, payload) => {
    state.mtaPaymentMonthlyError = payload
  },
  // CARDLESS
  SET_MTA_PAYMENT_QUOTE_CARDLESS: (state, status) => {
    state.mtaPaymentCardlessStatus = status
  },
  SET_MTA_PAYMENT_QUOTE_CARDLESS_LOADING: (state, payload) => {
    state.mtaPaymentCardlessLoading = payload
  },
  SET_MTA_PAYMENT_QUOTE_CARDLESS_ERROR: (state, payload) => {
    state.mtaPaymentCardlessError = payload
  },
  // RETRY
  SET_MTA_PAYMENT_RETRY: (state, status) => {
    state.mtaPaymentRetryStatus = status
  },
  SET_MTA_PAYMENT_RETRY_LOADING: (state, payload) => {
    state.mtaPaymentRetryLoading = payload
  },
  SET_MTA_PAYMENT_RETRY_ERROR: (state, payload) => {
    state.mtaPaymentRetryError = payload
  },

  RESET_MTA_QUOTE: (state, quote) => {
    state.mtaChanges = []
    state.mtaQuote = Object.assign({}, quote)
    state.mtaQuoteLoading = false
    state.mtaQuoteError = ''

    state.mtaPaymentAnnuallyStatus = null
    state.mtaPaymentAnnuallyLoading = false
    state.mtaPaymentAnnuallyError = ''

    state.mtaPaymentRetryStatus = null
    state.mtaPaymentRetryLoading = false
    state.mtaPaymentRetryError = ''

    state.mtaPaymentMonthlyStatus = null
    state.mtaPaymentMonthlyLoading = false
    state.mtaPaymentMonthlyError = ''

    state.mtaPaymentCardlessStatus = null
    state.mtaPaymentCardlessLoading = false
    state.mtaPaymentCardlessError = ''
  },
}
export const actions = {
  resetMtaQuote({ dispatch, commit }) {
    commit('RESET_MTA_QUOTE', resetQuote())
  },
  async createMtaQuote({ dispatch, commit, rootGetters }) {
    const email = rootGetters['user/userEmail']
    const quote = { ...rootGetters['quote/quote'] }
    quote.effectiveDate = this.$moment(new Date())

    const _quote = mapQuoteToApiFormat(quote, email)
    console.log('_quote before sent', _quote)
    commit('SET_MTA_QUOTE_LOADING', true)
    try {
      const mtaQuote = await this.$axios.$post(
        `/api/policy/v1/policy/${quote.code}/mta`,
        _quote
      )
      commit('SET_MTA_QUOTE', mapApiFormatToQuote(mtaQuote))
      commit('SET_MTA_QUOTE_LOADING', false)
      commit('SET_MTA_QUOTE_ERROR', '')
    } catch (error) {
      const { data } = error.response
      console.log('fetch mtaQuote by email error', error.response)
      console.log('fetch mtaQuote by email message', data.error)
      commit('SET_MTA_QUOTE', [])
      commit('SET_MTA_QUOTE_LOADING', false)
      commit('SET_MTA_QUOTE_ERROR', data.error)
    }
  },
  async payMtaQuoteMonthly({ dispatch, commit }, quote) {
    const _quote = mapQuoteToApiFormat(quote)
    console.log('quote action', _quote)
    commit('SET_MTA_PAYMENT_QUOTE_MONTHLY_LOADING', true)
    try {
      const mtaQuote = await this.$axios.$post(
        '/api/policy/v1/policy/mta/pay/monthly',
        _quote
      )
      commit('SET_MTA_PAYMENT_QUOTE_MONTHLY', mtaQuote.success)
      commit('SET_MTA_PAYMENT_QUOTE_MONTHLY_LOADING', false)
      commit('SET_MTA_PAYMENT_QUOTE_MONTHLY_ERROR', '')
    } catch (error) {
      console.log('fetch mtaQuote by email error', error)
      commit('SET_MTA_PAYMENT_QUOTE_MONTHLY', false)
      commit('SET_MTA_PAYMENT_QUOTE_MONTHLY_LOADING', false)
      commit('SET_MTA_PAYMENT_QUOTE_MONTHLY_ERROR', error)
    }
  },
  async payMtaQuoteAnnually({ dispatch, commit }, quote) {
    const _quote = mapQuoteToApiFormat(quote)
    console.log('quote action', _quote)
    commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY_LOADING', true)
    try {
      const mtaQuote = await this.$axios.$post(
        '/api/policy/v1/policy/mta/pay/annually',
        _quote
      )
      commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY', mtaQuote.success)
      commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY_LOADING', false)
      commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY_ERROR', '')
    } catch (error) {
      console.log('fetch mtaQuote by email error', error)
      commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY', false)
      commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY_LOADING', false)
      commit('SET_MTA_PAYMENT_QUOTE_ANNUALLY_ERROR', error)
    }
  },
  async payMtaQuoteCardless({ dispatch, commit }, quote) {
    console.log('quote', quote.quote)
    const _quote = mapQuoteToApiFormat(quote.quote)
    console.log('quote action', _quote)
    commit('SET_MTA_PAYMENT_QUOTE_CARDLESS_LOADING', true)
    try {
      const mtaQuote = await this.$axios.$post(
        '/api/policy/v1/policy/mta/pay/cardless',
        _quote
      )
      commit('SET_MTA_PAYMENT_QUOTE_CARDLESS', mtaQuote.success)
      commit('SET_MTA_PAYMENT_QUOTE_CARDLESS_LOADING', false)
      commit('SET_MTA_PAYMENT_QUOTE_CARDLESS_ERROR', '')
    } catch (error) {
      const message =
        error.response?.data?.error ??
        'Payment could not be completed, please try again.'
      console.log('MAT GOCARDLESS ERROR:', message)
      commit('SET_MTA_PAYMENT_QUOTE_CARDLESS', false)
      commit('SET_MTA_PAYMENT_QUOTE_CARDLESS_LOADING', false)
      commit('SET_MTA_PAYMENT_QUOTE_CARDLESS_ERROR', message)
    }
  },
  async retryMtaPayment({ dispatch, commit }, { quote, card }) {
    console.log('quote action pid', quote.pid)
    console.log('quote action card', card)
    commit('SET_MTA_PAYMENT_RETRY_LOADING', true)
    try {
      const result = await this.$axios.$post(
        '/api/policy/v1/policy/mta/pay-retry',
        {
          pid: quote.pid,
          card,
        }
      )
      commit('SET_MTA_PAYMENT_RETRY', result.success)
      commit('SET_MTA_PAYMENT_RETRY_LOADING', false)
      commit('SET_MTA_PAYMENT_RETRY_ERROR', '')
    } catch (error) {
      console.log('fetch mtaQuote by email error', error)
      commit('SET_MTA_PAYMENT_RETRY', false)
      commit('SET_MTA_PAYMENT_RETRY_LOADING', false)
      commit('SET_MTA_PAYMENT_RETRY_ERROR', error)
    }
  },
}
